import SyncAltIcon from "@mui/icons-material/SyncAlt";

const icons = {
    SyncAltIcon,
};

const insurerSummaryReport = {
    id: "insurerSummaryReport",
    type: "group",
    children: [
        {
            id: "insurer_plan_update",
            title: "Insurer Plan Update",
            type: "item",
            url: "/insurerUploadSummary",
            icon: icons.SyncAltIcon,
        },
    ],
};

export default insurerSummaryReport;